import { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import MDBox from "components/MDBox";
import { Card } from "@mui/material";
import * as Yup from "yup";
import { MuiOtpInput } from "mui-one-time-password-input";
import bgImage from "assets/images/login-icon.jpg";
import MDTypography from "components/MDTypography";
import Cookies from "js-cookie";
import { LoginFormContext } from "context/LoginFormContext";
import { forgotPassword } from "Apis/signIn";
import { AuthRouteJson } from "helpers/constant";
import SubmitButton from "components/SubmitButton";
import colors from "assets/theme/base/colors";

export const OtpConfirmation = () => {
  const navigate = useNavigate();
  const { setNotification } = useContext(LoginFormContext);
  const [counter, setCounter] = useState(59);
  const [otpEmail, setOtpEmail] = useState("");
  const [isCounting, setIsCounting] = useState(false);
  const [otp, setOtp] = useState("");
  const { sideNav } = colors;

  const intervalRef = useRef(null);
  useEffect(() => {
    setOtpEmail(Cookies.get("otpEmail"));
  }, []);

  const initialValues = {
    otp: "",
  };
  const ValidationSchema = Yup.object({
    otp: Yup.string().min(6).max(6).required("Please enter valid OTP!"),
  });

  useEffect(() => {
    if (isCounting && counter > 0) {
      intervalRef.current = setInterval(() => {
        setCounter((prevCounter) => prevCounter - 1);
      }, 1000);
    } else {
      clearInterval(intervalRef.current);
    }
    return () => clearInterval(intervalRef.current);
  }, [isCounting, counter]);

  const handleSubmit = async (values) => {
    const get_otp = Cookies.get("otp");
    if (values?.otp === get_otp) {
      navigate(AuthRouteJson.resetpassword);
    } else {
      setNotification({
        color: "error",
        icon: "cancel",
        title: "Error",
        content: "Invalid Otp",
        open: true,
      });
    }
  };

  const resendOTP = async () => {
    setCounter(59);
    setIsCounting(true);
    formik.setFieldValue("otp", "");
    let response = await forgotPassword({ email: otpEmail });
    if (response?.status === 200) {
      Cookies.set("otp", response?.data?.data?.otp);
      setNotification({
        color: "success",
        icon: "check",
        title: "Success",
        content: response.data.message,
        open: true,
      });
    } else {
      setNotification({
        color: "error",
        icon: "cancel",
        title: "Error",
        content: response.data.message,
        open: true,
      });
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: ValidationSchema,
    onSubmit: handleSubmit,
  });

  const handleChange = (newValue) => {
    setOtp(newValue);
    formik.setFieldValue("otp", newValue);
  };
  return (
    // <CoverLayout>
    <MDBox
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100vh",
        width: "100%",
        justifyContent: "center",
        background: `${sideNav.hover}`,
      }}
    >
      <MDBox
        sx={{
          display: "flex",
          alignItems: "center",
          width: "80%",
          maxWidth: "1030px",
          padding: "20px",
          gap: "25px",
          background: "#fff",
          borderRadius: "8px",
          margin: "0 auto",
          justifyContent: "center",
          "@media (max-width:1020px)": {
            flexDirection: "column",
          },
          "@media (max-width:767px)": {
            width: "90%",
          },
        }}
      >
        <MDBox
          sx={{
            width: "auto",
            height: "460px",
            "@media (max-width: 1020px)": { width: "auto", height: "170px" },
          }}
        >
          <img
            src={bgImage}
            width={100}
            height={100}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </MDBox>
        <Card
          sx={{
            gap: "10px",
            width: "52%",
            background: "transparent",
            boxShadow: "none",
            "@media (max-width:1020px)": {
              width: "100%",
            },
          }}
        >
          <MDBox textAlign="center">
            <MDTypography
              variant="h4"
              mb="8px"
              fontWeight="medium"
              color="#334155"
              fontSize="1.5rem"
            >
              Otp Verification
            </MDTypography>
          </MDBox>
          <MDBox p={{ xl: 2.25 }}>
            <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
              <MDBox mb={2.25}>
                <MuiOtpInput value={otp} onChange={handleChange} length={6} />

                {formik.touched.otp && formik.errors.otp && (
                  <MDBox
                    component="p"
                    sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
                  >
                    {formik.errors.otp}
                  </MDBox>
                )}
              </MDBox>

              <MDBox component="p" sx={{ marginTop: "5px", fontSize: "16px", textAlign: "center" }}>
                Didn‘t receive an OTP?
                <MDBox component="strong" sx={{ marginLeft: "8px", cursor: "pointer" }}>
                  <MDBox component="span" onClick={resendOTP}>
                    Resend OTP
                  </MDBox>
                </MDBox>
              </MDBox>
              {isCounting === true && counter !== 0 && (
                <MDBox
                  component="p"
                  sx={{ fontSize: "14px", textAlign: "center", marginTop: "5px" }}
                >
                  Time Remaining : <strong>{counter}s</strong>
                </MDBox>
              )}
              <MDBox mt={3} mb={1}>
                <SubmitButton type="submit" btnText={"submit"} width="100%" />
              </MDBox>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
    </MDBox>
    // </CoverLayout>
  );
};
